const colourStyle = (color: string) => {
  switch (color) {
    case "primary":
      return "#0082b4";

    case "danger":
      return "#de051a";

    case "secondary":
      return "#A5A5A5";

    case "success":
      return "#87D25B";

    default:
      return;
  }
};

export default colourStyle;
